import { lenis } from "./lenis.js";

const init = () => {
    // Project Category Filtering
    const projectCategories = document.querySelectorAll('.project-categories li');
    const projectItems = document.querySelectorAll('.project-item');

    // Mobile Dropdown Toggle
    const categoryToggles = document.querySelectorAll('.project-categories__toggle');
    categoryToggles.forEach(toggle => {
        toggle.addEventListener('click', function() {
            const isOpen = this.classList.toggle('is-open');
            this.setAttribute('aria-expanded', isOpen);
            const ul = this.nextElementSibling;
            if (ul) ul.classList.toggle('is-open');
        });

        // Keyboard Support for toggle
        toggle.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.click();
            }
        });
    });

    if (projectCategories.length > 0 && projectItems.length > 0) {
        projectCategories.forEach(category => {
            // Remove existing event listeners to prevent duplicates if re-initializing
            // Note: anonymous functions can't be easily removed, so we might need a better approach 
            // if this init is called multiple times on the same elements.
            // However, with Barba, the container is usually replaced, so new elements are created.
            // If the elements persist (outside barba container), we need to be careful.
            // Assuming these are inside the barba container for now.
            
            category.addEventListener('click', function (e) {
                e.preventDefault();
                
                // Scroll to top
                if (!document.querySelector('.project-wrapper--grid')) {
                    if (lenis) {
                        lenis.scrollTo(0);
                    } else {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                }
                
                // Prevent creating multiple intervals/timeouts if clicked rapidly
                if (this.classList.contains('processing')) return;
                
                const slug = this.getAttribute('data-slug');
                let targetSlug = slug;
                let isResetting = false;

                // Determine target state
                if (slug === 'all') {
                     if (this.classList.contains('active')) return; // Already showing all
                     targetSlug = 'all';
                } else {
                    if (this.classList.contains('active')) {
                        // Deactivating -> Show all
                        targetSlug = 'all';
                        isResetting = true;
                    } 
                    // else -> targetSlug is the new category
                }

                // Update UI classes
                projectCategories.forEach(cat => {
                    cat.classList.remove('active');
                    cat.setAttribute('aria-selected', 'false');
                });
                if (slug === 'all') {
                    this.classList.add('active');
                    this.setAttribute('aria-selected', 'true');
                } else {
                    if (isResetting) {
                        const allBtn = document.querySelector('.project-categories li[data-slug="all"]');
                        if (allBtn) {
                            allBtn.classList.add('active');
                            allBtn.setAttribute('aria-selected', 'true');
                        }
                    } else {
                        this.classList.add('active');
                        this.setAttribute('aria-selected', 'true');
                    }
                }

                // Update specific toggle label relative to this category and close dropdown
                const parentContainer = this.closest('.project-categories');
                if (parentContainer) {
                     const toggle = parentContainer.querySelector('.project-categories__toggle');
                     const label = parentContainer.querySelector('.current-label');
                     const ul = parentContainer.querySelector('ul');
                     
                     if (label) label.textContent = this.textContent.trim();
                     if (toggle) {
                        toggle.classList.remove('is-open');
                        toggle.setAttribute('aria-expanded', 'false');
                     }
                     if (ul) ul.classList.remove('is-open');
                }
                
                // Animation Logic
                const itemsToHide = [];
                const itemsToShow = [];
                
                projectItems.forEach(item => {
                    const matches = targetSlug === 'all' || item.classList.contains('project-category-' + targetSlug);
                    
                    if (matches) {
                        if (item.classList.contains('is-hidden') || item.style.display === 'none') {
                            itemsToShow.push(item);
                        }
                    } else {
                        if (!item.classList.contains('is-hidden') && item.style.display !== 'none') {
                            itemsToHide.push(item);
                        }
                    }
                });
                
                // 1. Fade out items to hide
                itemsToHide.forEach(item => {
                    item.classList.add('is-fading');
                });
                
                // Block interaction during transition
                projectCategories.forEach(cat => cat.classList.add('processing'));
                
                const delay = itemsToHide.length > 0 ? 400 : 0;
                
                setTimeout(() => {
                    // 2. Remove hidden items from flow
                    itemsToHide.forEach(item => {
                        item.classList.add('is-hidden');
                        item.classList.remove('is-fading');
                        item.style.display = ''; // Clear inline display if any
                    });
                    
                    // 3. Prepare items to show (invisible but in flow)
                    itemsToShow.forEach(item => {
                        item.classList.add('is-fading');
                        item.classList.remove('is-hidden');
                        item.style.display = ''; 
                    });
                    
                    // Force reflow
                    if (itemsToShow.length > 0) {
                        void itemsToShow[0].offsetWidth; 
                    }
                    
                    // 4. Fade in
                    itemsToShow.forEach(item => {
                        item.classList.remove('is-fading');
                    });
                    
            projectCategories.forEach(cat => cat.classList.remove('processing'));
                
                }, delay);
            });

            // Keyboard support for tabs
            category.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.click();
                }
            });
        });
    }

    // Contact Form 7 - Accessibility (inputs, textareas, selects)
    const cf7Controls = document.querySelectorAll('.wpcf7-input, .wpcf7-textarea, .wpcf7-select, .wpcf7-form-control');
    cf7Controls.forEach(control => {
        if (control.dataset.accInitialized) return; // Prevent multiple initializations

        const placeholder = control.getAttribute('placeholder');
        if (placeholder) {
            control.setAttribute('aria-label', placeholder);
        }
        control.dataset.accInitialized = 'true';
    });

    // Contact Form 7 - Checkbox & Radio accessibility
    const cf7Toggles = document.querySelectorAll('.wpcf7-checkbox input[type="checkbox"], .wpcf7-radio input[type="radio"], .wpcf7-acceptance input[type="checkbox"]');
    cf7Toggles.forEach(toggle => {
        if (toggle.dataset.toggleAccInitialized) return;

        // Set initial state
        toggle.setAttribute('aria-checked', toggle.checked);
        
        // Sync aria-checked on change
        toggle.addEventListener('change', function() {
            if (this.type === 'radio') {
                // If radio, update everyone in the same group
                const group = document.querySelectorAll(`input[name="${this.name}"]`);
                group.forEach(r => r.setAttribute('aria-checked', r.checked));
            } else {
                this.setAttribute('aria-checked', this.checked);
            }
        });

        // Ensure toggle has an aria-label if it's missing (using label sibling)
        if (!toggle.getAttribute('aria-label')) {
            const labelSpan = toggle.closest('label')?.querySelector('.wpcf7-list-item-label');
            if (labelSpan) {
                toggle.setAttribute('aria-label', labelSpan.textContent.trim());
            }
        }
        toggle.dataset.toggleAccInitialized = 'true';
    });
};

export { init };